import { getCanonicalShiftStatus, getShiftStartMs, getShiftEndMs } from './shiftLifecycle';

// Display only: never persist this value or use it to authorize lifecycle actions.
export function getOperationalShiftState(shift, now = Date.now()) {
  const status = getCanonicalShiftStatus(shift);
  const start = getShiftStartMs(shift), end = getShiftEndMs(shift);
  return status === 'arrived' && Number.isFinite(start) && Number.isFinite(end)
    && start < end && now >= start && now < end ? 'on_shift' : status;
}
